var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(_vm.style),attrs:{"src":"https://res.cloudinary.com/gathertech/image/upload/v1658903825/platform/logos/gatherworks-logo-750px_xlth4n.png","height":_vm.height,"alt":"Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }